// Utilities
import { makeStyles } from "@fluentui/react-components";
import { flexParent } from "@ms/planner-generic-controls/lib/local/utilities/Mixin.styles";
const optionsListTopPadding = "11px";
/**
 * Styles for LeftNavStaticSection component
 */ export const useLeftNavStaticSectionStyles = makeStyles({
    root: {
        ...flexParent("column"),
        flexShrink: 0,
        minHeight: "auto",
        overflow: "visible"
    },
    collapsed: {
        // Styles when left nav is collapsed (width: 38px)
        // In collapsed state, typically only icons are visible
        // The container width is managed by parent, but we ensure content fits
        maxWidth: "38px"
    },
    optionsList: {
        ...flexParent("column"),
        flexShrink: 0,
        listStyle: "none",
        margin: "0 0 8px",
        padding: `${optionsListTopPadding} 0 0`,
        overflow: "visible",
        minHeight: "auto"
    }
});
